import type { ReactNode } from 'react';
import { ThemeProvider } from 'next-themes';
import { useLocation } from 'react-router-dom';
import { getForcedRouteTheme } from '@/config/routeTheme';

export const RouteThemeProvider = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      forcedTheme={getForcedRouteTheme(pathname)}
    >
      {children}
    </ThemeProvider>
  );
};